import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'; 
import API_URL from "../../ApiUrl/ApiUrl";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Booking = () => {
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/carbooks`)
      .then((response) => {
        setBookings(response.data);
      })
      .catch((error) => {
        console.error('Error fetching bookings:', error);
      });
  }, []);

  const HandleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this booking?");
    if (confirmDelete) {
      try {
        const response = await axios.delete(`${API_URL}/carbook/${id}`);

        setBookings(bookings.filter((booking) => booking._id !== id));

        toast.error("Booking Deleted Successfully!", {
          position: "top-center",
        });
      } catch (error) {
        console.error('Error deleting the booking:', error);
      }
    }
  };

  return (
    <>
       <ToastContainer/>
    <div className="content-wrapper pb-2 mb-0">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3 className="m-0 text-dark">Booking Management</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Driver Management</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table id="custtbl" className="table card-table table-vcenter">
                  <thead style={{ whiteSpace: 'nowrap' }}>
                    <tr className="bookingtable">
                      <th className="w-1">S. No.</th>
                      <th className="w-1">First Name</th>
                      <th>Last Name</th>
                      <th>Phone Number</th>
                      <th>Email</th>
                     
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Vehicle</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="bookingtable" style={{ whiteSpace: 'nowrap' }}>
                    {bookings.map((booking, index) => (
                      <tr key={booking._id}>
                        <td>{index + 1}</td>
                        <td>{booking.fname || 'N/A'}</td>
                        <td>{booking.lname || 'N/A'}</td>
                        <td>{booking.phone || 'N/A'}</td>
                        <td>{booking.email || 'N/A'}</td>
                      
                        <td>{new Date(booking.start_date).toLocaleDateString()}</td>
                        <td>{new Date(booking.end_date).toLocaleDateString()}</td>
                        <td>{booking.carDetails?.carName || 'N/A'}</td>
                        <td>
                          <Link className="icon">
                            <i className="fa fa-eye" />
                          </Link> |
                          <Link className="icon text-danger" onClick={()=>HandleDelete(booking._id)}>
                            <i className="fa fa-trash" />
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pagination (if required) */}
      <nav aria-label="Page navigation example">
        <ul className="pagination mt-4 float-end">
          <li className="page-item">
            <a className="page-link" href="#">
              Previous
            </a>
          </li>
          <li className="page-item">
            <a className="page-link" href="#">
              1
            </a>
          </li>
          <li className="page-item">
            <a className="page-link" href="#">
              2
            </a>
          </li>
          <li className="page-item">
            <a className="page-link" href="#">
              3
            </a>
          </li>
          <li className="page-item">
            <a className="page-link" href="#">
              Next
            </a>
          </li>
        </ul>
      </nav>
    </div>
    </>
  );
};

export default Booking;
